import { AcastGlyph } from '@acast-tech/decibel-glyphs';
import T from 'prop-types';
import styled from 'styled-components';
import { black, white, whiteAlpha16, yellow } from '../../styles/colors';
import { body1, body2 } from '../../styles/typography';
import { unit } from '../../styles/unit';
import { Icon } from '../Icon/Icon';
import { NavigationColumn as GlobalNavigationColumn } from '../NavigationColumn/NavigationColumn';
import { ThemeProvider } from '../ThemeProvider/ThemeProvider';
import { GlobalNavigationItem } from './GlobalNavigationItem';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const Container = /*#__PURE__*/styled.nav.withConfig({
  displayName: "Container",
  componentId: "sc-1xnilze-0"
})(["", " background-color:", ";height:60px;display:flex;align-items:center;padding:0 ", ";overflow:visible;"], body1, black, unit(4));
const Title = /*#__PURE__*/styled.p.withConfig({
  displayName: "Title",
  componentId: "sc-1xnilze-1"
})(["", " color:", ";margin-left:", ";white-space:nowrap;"], body2, white, unit(2));
const Divider = /*#__PURE__*/styled.div.withConfig({
  displayName: "Divider",
  componentId: "sc-1xnilze-2"
})(["color:", ";width:1px;height:24px;background-color:", ";margin:0 ", ";"], white, whiteAlpha16, unit(4));

const GlobalNavigation = ({
  title,
  children
}) => /*#__PURE__*/_jsx(ThemeProvider, {
  theme: {
    type: 'dark'
  },
  children: /*#__PURE__*/_jsxs(Container, {
    children: [/*#__PURE__*/_jsxs(GlobalNavigationColumn, {
      as: "header",
      align: "left",
      children: [/*#__PURE__*/_jsx(Icon, {
        glyph: AcastGlyph,
        size: "medium",
        primaryColor: yellow
      }), title && /*#__PURE__*/_jsx(Title, {
        children: title
      }), /*#__PURE__*/_jsx(Divider, {})]
    }), /*#__PURE__*/_jsx(GlobalNavigationColumn, {
      align: "left",
      stretch: true,
      children: children
    })]
  })
});

GlobalNavigation.propTypes = {
  title: T.string,
  children: T.node
};
export { GlobalNavigation, GlobalNavigationColumn, GlobalNavigationItem };